import { Link } from "react-router-dom";
import { categories } from "@/mocks/anime";

export default function Footer() {
  return (
    <footer className="w-full bg-primary-950 text-background-100 mt-16">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-tv-2-fill text-xl"></i>
              </span>
              <span className="font-heading font-extrabold text-lg text-background-50">
                动漫免费在观看
              </span>
            </div>
            <p className="text-sm leading-relaxed text-background-300">
              一个专注高清动漫在线播放的免费平台，覆盖热血、校园、科幻、经典等丰富类型，随时随地享受顺畅的观影体验。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-900/60 text-background-100">
                <i className="ri-wechat-line text-lg"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-900/60 text-background-100">
                <i className="ri-weibo-line text-lg"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-900/60 text-background-100">
                <i className="ri-mail-line text-lg"></i>
              </span>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-bold text-background-50 mb-4">
              <Link to="/category/hotblood" className="hover:text-primary-300 transition-colors">热门分类</Link>
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.id}>
                  <Link to={`/category/${cat.id}`} className="text-sm text-background-300 hover:text-primary-300 transition-colors">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-background-50 mb-4">
              <Link to="/" className="hover:text-primary-300 transition-colors">快速导航</Link>
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-background-300 hover:text-primary-300 transition-colors">首页</Link></li>
              <li><Link to="/category/hotblood" className="text-sm text-background-300 hover:text-primary-300 transition-colors">动漫分类</Link></li>
              <li><Link to="/search" className="text-sm text-background-300 hover:text-primary-300 transition-colors">搜索动漫</Link></li>
              <li><Link to="/about" className="text-sm text-background-300 hover:text-primary-300 transition-colors">关于我们</Link></li>
              <li><Link to="/about" className="text-sm text-background-300 hover:text-primary-300 transition-colors">意见反馈</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-background-50 mb-4">
              <Link to="/about" className="hover:text-primary-300 transition-colors">联系我们</Link>
            </h4>
            <ul className="space-y-3 text-sm text-background-300">
              <li className="flex items-start gap-2">
                <i className="ri-mail-send-line mt-0.5 text-primary-300"></i>
                <span>support@dongmanfree.example</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line mt-0.5 text-primary-300"></i>
                <span>400-888-6666（工作日 9:00-18:00）</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5 text-primary-300"></i>
                <span>上海市浦东新区动漫大道 88 号</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-800/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400 text-center sm:text-left">
            © 2026 动漫免费在观看 · 本站为前端演示站点，所有视频与数据均为演示内容，无真实视频流接入。
          </p>
          <div className="flex items-center gap-4 text-xs text-background-400">
            <Link to="/about" className="hover:text-primary-300 transition-colors">用户协议</Link>
            <Link to="/about" className="hover:text-primary-300 transition-colors">隐私政策</Link>
            <span>仅供学习交流使用</span>
          </div>
        </div>
      </div>
    </footer>
  );
}